export interface YooKassaError {
  cancel_by?: string
  cancel_reason?: string
}

const YOOKASSA_ERROR_CODE_MAP: Record<string, string> = {
  '3d_secure_failed':
    'Не пройдена аутентификация по 3-D Secure. При новой попытке оплаты пользователю следует пройти аутентификацию, использовать другое платежное средство или обратиться в банк за уточнениями',
  call_issuer:
    'Оплата данным платежным средством отклонена по неизвестным причинам. Пользователю следует обратиться в организацию, выпустившую платежное средство',
  canceled_by_merchant: 'Платеж отменен по API при оплате в две стадии',
  card_expired:
    'Истек срок действия банковской карты. При новой попытке оплаты пользователю следует использовать другое платежное средство',
  country_forbidden:
    'Нельзя заплатить банковской картой, выпущенной в этой стране.',
  expired_on_capture: 'Истек срок списания оплаты у двухстадийного платежа. ',
  expired_on_confirmation:
    'Истёк срок оплаты: пользователь не подтвердил платеж за время, отведенное на оплату выбранным способом. ',
  fraud_suspected:
    'Платеж заблокирован из-за подозрения в мошенничестве. При новой попытке оплаты пользователю следует использовать другое платежное средство',
  general_decline:
    'Причина не детализирована. Пользователю следует обратиться к инициатору отмены платежа за уточнением подробностей',
  identification_required:
    'Превышены ограничения на платежи для кошелька ЮMoney. При новой попытке оплаты пользователю следует идентифицировать кошелек или выбрать другое платежное средство',
  insufficient_funds:
    'Не хватает денег для оплаты. Пользователю следует пополнить баланс или использовать другое платежное средство',
  internal_timeout:
    'Технические неполадки на стороне ЮKassa: не удалось обработать запрос в течение 30 секунд. Повторите платеж с новым ключом идемпотентности',
  invalid_card_number:
    'Неправильно указан номер карты. При новой попытке оплаты пользователю следует ввести корректные данные',
  invalid_csc:
    'Неправильно указан код CVV2 (CVC2, CID). При новой попытке оплаты пользователю следует ввести корректные данные',
  issuer_unavailable:
    'Организация, выпустившая платежное средство, недоступна. При новой попытке оплаты пользователю следует использовать другое платежное средство или повторить оплату позже',
  payment_method_limit_exceeded:
    'Исчерпан лимит платежей для данного платежного средства или вашего магазина. При новой попытке оплаты пользователю следует использовать другое платежное средство или повторить оплату на следующий день',
  payment_method_restricted:
    'Запрещены операции данным платежным средством (например, карта заблокирована из-за утери, кошелек — из-за взлома мошенниками). Пользователю следует обратиться в организацию, выпустившую платежное средство',
  permission_revoked:
    'Нельзя провести безакцептное списание: пользователь отозвал разрешение на автоплатежи. Если пользователь еще хочет оплатить, вам необходимо создать новый платеж, а пользователю — подтвердить оплату',
  unsupported_mobile_operator:
    'Нельзя заплатить с номера телефона этого мобильного оператора. При новой попытке оплаты пользователю следует использовать другое платежное средство'
}

const YOOKASSA_SOURCES_MAP: Record<string, string> = {
  yandex_checkout: 'Яндекс/Юкасса'
}

export const translateErrorCodeToMessage = (code?: string) =>
  code && YOOKASSA_ERROR_CODE_MAP.hasOwnProperty(code)
    ? YOOKASSA_ERROR_CODE_MAP[code]
    : `Неизвестная ошибка! Код ошибки: ${code}`

export const translateErrorSouce = (source?: string) =>
  source && YOOKASSA_SOURCES_MAP.hasOwnProperty(source)
    ? YOOKASSA_SOURCES_MAP[source]
    : source

export const parseYookassaError = (error: YooKassaError = {}) => {
  return {
    issuer: translateErrorSouce(error?.cancel_by),
    message: translateErrorCodeToMessage(error?.cancel_reason)
  }
}
